// Generated by CoffeeScript 2.7.0
var SettingsWechatAuthorized;

import SettingsContainer from 'trunks/vue/admin/components/settings/settings_container.js';

export default SettingsWechatAuthorized = Vue.extend({
  components: {
    'settings-container': SettingsContainer
  },
  props: {
    activeTab: {
      type: String
    },
    authorized: {
      type: Boolean
    },
    authorityIds: {
      type: Array
    },
    authorizeUrl: {
      type: String
    },
    wechatAccessList: {
      type: Array
    }
  },
  template: `<settings-container :activeTab="activeTab">
  <template slot="content">
    <div class="wechat-authorized-list">
      <div class="list-item"
           v-for="(item, index) in wechatAccessList"
           :key="index">
        <div class="title">{{ item }}</div>
        <div class="select">
          <i :class="statusClass(index)"></i>
        </div>
      </div>
    </div>
    <div class="content-footer">
      <button class="content-footer-btn"
              @click="reAuthorize">重新授权</button>
    </div>
  </template>
</settings-container>`,
  methods: {
    statusClass: function(index) {
      var result;
      result = this._getBoolean(index);
      if (this.authorized) {
        return {
          "slp-check-circle": result,
          "success-text": result,
          "error-text": !result,
          "slp-times-circle": !result
        };
      } else {
        return {
          "slp-times-circle": true,
          "error-text": true
        };
      }
    },
    _getBoolean: function(index) {
      return _.some(this.authorityIds, function(item) {
        return item === index;
      });
    },
    reAuthorize: function() {
      return location.href = this.authorizeUrl;
    }
  }
});
